<button 
    size="small" 
    p-button  
    [pTooltip]="data.length > 0 ? tooltipContent : ''" 
    tooltipPosition="bottom" 
    class="ml-3 split-button-orange-1" 
    [class.active]="data.length > 0" 
    type="button" 
    (click)="showOverlayPanel($event)">
    {{label}}
</button>
<p-overlayPanel #op (onHide)="hideOverlayPanel()" appendTo="body">
    <div class="split-calendar-panel flex w-full">
        <p-calendar (click)="$event.stopPropagation()" [(ngModel)]="_data" class="w-full" selectionMode="range" [inline]="true" >
            <ng-template pTemplate="header">
                <div class="flex align-items-center justify-content-center mb-3">
                    <p-inputMask [ngModel]="_data[0] | date:'dd/MM/yyyy'" (onInput)="onInput($event, 0)" mask="99/99/9999"></p-inputMask>
                    <split-icon class="mx-3" name="arrow-narrow-right"></split-icon>
                    <p-inputMask [ngModel]="_data[1] | date:'dd/MM/yyyy'"  (onInput)="onInput($event, 1)"  mask="99/99/9999"></p-inputMask>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <div class="flex justify-content-between mt-3">
                    <p-button (click)="onCancel()" label="cancelar" [outlined]="true"  severity="secondary"></p-button>
                    <p-button [disabled]="!_data[0] || !_data[1]" (click)="onEmit()" label="aplicar"></p-button>
                </div>
            </ng-template>
        </p-calendar>
    </div>
</p-overlayPanel>

<ng-template #tooltipContent>
   <p class="my-1">Filtros selecionados: </p>
   <div class="flex align-items-center justify-content-center">
        <span>{{_data[0] | date:'dd/MM/yyyy'}} - {{_data[1] | date:'dd/MM/yyyy'}}</span>
   </div>
</ng-template>